<script>
	import {beforeUpdate,onMount} from "svelte";
	import Controlador from "../controlador.svelte";
	import {docs} from "../store";
	export let item;
	let c;
	let tipo = "producto";
	let nombre = "";
	let costo = 0;
	let precio = 0;
	let categoria = 0;
	let descripcion = "";
	let locales = [
		{nombre:"San Martin", cantidad: 50},
		{nombre:"Costa", cantidad: 50},
		{nombre:"Santa Fe", cantidad: 50},
		{nombre:"Güemes", cantidad: 50},
	];
	let icon = {
		"Servicio": "ri-service-line",
		"Producto": "ri-shopping-bag-3-line"
	}
	let togle = false;
	let iconEye = "ri-eye-line";
	onMount(()=>{
		let categorias = $docs.find((el)=>el._id == "config:categorias").categorias;
		let stockSanMartin = $docs.find((el)=> el._id == "local:San Martin").stock;
		categoria = categorias.findIndex((el)=>el == item.categoria);

		let cajaSanMartin = $docs
		.filter((el)=>el._id.includes(`caja:San Martin`))
		.filter((el)=>{
			let fechael = new Date(el.fecha);
			let fecha = new Date();
			fechael.setHours(0,0,0,0);
			fecha.setHours(0,0,0,0);
			return fechael.getTime() < fecha.getTime()
		})
		.sort((a,b)=>{
			let fechaA = new Date(a.fecha);
			let fechaB = new Date(b.fecha);
			fechaA.setHours(0,0,0,0);
			fechaB.setHours(0,0,0,0);
			return fechaB.getTime() - fechaA.getTime()
		})[0];
		if (cajaSanMartin.stock[item._id]){
			let valor = Number(stockSanMartin);
			locales[0].cantidad = (stockSanMartin? valor : 50) - Number(cajaSanMartin.stock[item._id]);
		}
	})
	beforeUpdate(()=>{
		if (item){
			
		}
		if (item){
			tipo = item.tipo;
			nombre = item.nombre;
			costo = item.costo;
			precio = item.precio;
		}
	})
	function activeTogle(){
		togle = !togle;
		iconEye = (!togle? "ri-eye-line" : "ri-eye-close-line");
	}
	function eliminar(){
		c.eliminarDeposito(item);
	}
</script>
<Controlador bind:this={c} />
<div class="w-full sm:w-3/4 flex flex-col items-center m-2 p-2 bg-white rounded shadow">
		<div class="w-full flex items-center">
			<div class="p-2 border-r-2 border-red-500">
				<i class={`${icon[tipo]} text-2xl`} />
			</div>
			<div class="p-2 flex flex-col items-start w-full">
				<span class="text-xs font-bold">Nombre</span>
				<p>{nombre}</p>
			</div>
			{#if tipo == "producto"}
			<div class="p-2 flex flex-col items-start">
				<span class="text-xs font-bold">Costo</span>
				<p>${costo}</p>
			</div>
			<div class="p-2 flex flex-col items-start">
				<span class="text-xs font-bold">Precio</span>
				<p>${precio}</p>
			</div>	
			{/if}	
			<div class="p-2 flex  items-center">
				{#if tipo == "Producto"}
					<button on:click={activeTogle} class="p-2 mx-2 bg-red-500 text-white flex items-center justify-center rounded shadow">
						<i class={iconEye} />
				</button>
				{/if}
				<a href={`#/deposito/${categoria}/${item._id}`} class="p-2 mx-2 bg-red-500 text-white flex items-center justify-center rounded shadow">
					<i class="ri-edit-line" />
				</a>
				<button on:click={eliminar} class="p-2 mx-2 bg-red-500 text-white flex items-center justify-center rounded shadow">
					<i class="ri-delete-bin-5-line" />
				</button>
			</div>
		</div>
		{#if togle && tipo == "Producto"}
		<div class="w-full p-2 flex flex-col items-start">
			<span class="text-sm font-bold">STOCK</span>
			<div class="w-full flex items-center justify-between">
				{#each locales as e}
				<div class="text-xs mx-2">
					<span class="font-bold text-xs">{e.nombre}: </span>
					{e.cantidad}
				</div>
				{/each}
			</div>
		</div>
		{/if}
</div>
